export default __webpack_public_path__ + "static/media/helpMap.90ee524a.png";